export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7936.4ea5649a.jpg";